module.exports = __webpack_public_path__ + "static/media/ITCAvantGardeStd-Bold.755d9f00.svg";